import {TProvider} from './types';

export const CONFIRM_AND_SCHEDULE = 'Confirm & Schedule';
export const INTERVIEW_TYPE = 'Interview type';
export const HOW_IT_WORKS = 'How it Works';
export const ENTER_KEY_CODE = 13;
export const VERIFY_EMAIL = 'Verify email';
export const FACEBOOK: TProvider = 'facebook';
export const GOOGLE: TProvider = 'google';
export const PRAMP: TProvider = 'pramp';
export const CANCEL = 'cancel';
export const NEXT = 'next';
export const BACK = 'back';
